import { useParams, Navigate } from "react-router-dom";
import SubcategoryPageLayout from "@/components/SubcategoryPageLayout";
import ferroSubs from "@/data/ferroSubcategories";

const FerroSubcategoryPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const sub = slug ? ferroSubs[slug] : null;

  if (!sub) return <Navigate to="/ferro" replace />;

  return (
    <SubcategoryPageLayout
      heading={sub.heading}
      subtitle={sub.subtitle}
      categoryKey={sub.categoryKey}
      backTo="/ferro"
      backLabel="Ferro & Sicurezza"
    />
  );
};

export default FerroSubcategoryPage;
